import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { InviteMemberCompleteTemplate } from 'components/Templates'

const InviteMemberComplete: FC = () => {
  return (
    <Layout title={'メンバーを招待完了'}>
      <InviteMemberCompleteTemplate />
    </Layout>
  )
}

export default InviteMemberComplete
